import { render, staticRenderFns } from "./OrganizingPartners.vue?vue&type=template&id=6b51b7af&scoped=true&"
import script from "./OrganizingPartners.vue?vue&type=script&lang=js&"
export * from "./OrganizingPartners.vue?vue&type=script&lang=js&"
import style0 from "./OrganizingPartners.vue?vue&type=style&index=0&id=6b51b7af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51b7af",
  null
  
)

export default component.exports